import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ListGroup from "../../../../atoms/listGroup";
import { GlobalGet } from "../../../../../helpers/fetcher";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Environtment from "../../../../../constant/environtment.json";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const Screen = () => {
  const { REACT_APP_API_URL } = Environtment;
  const role = localStorage.getItem("role");
  const [revenue, setRevenue] = useState([]);
  let amount = [];
  let year = [];
  let quartal = [];
  const data = {
    labels: [2018, 2019, 2020, 2021, 2022],
    datasets: [
      {
        label: "Quartal 1",
        data: [200, 500, 700, 400, 300],
        backgroundColor: "rgb(19, 76, 108)",
      },
      {
        label: "Quartal 2",
        data: [100, 600, 550, 300, 600],
        backgroundColor: "rgb(232, 142, 8)",
      },
      {
        label: "Quartal 3",
        data: [500, 800, 200, 600, 500],
        backgroundColor: "rgb(11, 89, 14)",
      },
      {
        label: "Quartal 4",
        data: [800, 200, 200, 400, 400],
        backgroundColor: "rgba(208, 219, 12, 0.8)",
      },
    ],
  };
  const options = {
    responsive: true,
  };
  const getDataRevenue = async () => {
    try {
      const respons = await GlobalGet({ url: `${REACT_APP_API_URL}revenue` });
      for (const dataObj of respons?.data?.portofolio) {
        amount.push(parseInt(dataObj.amount));
        year.push(parseInt(dataObj.year));
        quartal.push(parseInt(dataObj.quartal));
      }
    } catch (error) {
      console.log(error);
    }
  };

  var uniqueYear = [];
  var uniqueYear = year.filter(function (elem, pos) {
    return year.indexOf(elem) == pos;
  });

  console.log(amount);
  console.log(uniqueYear);
  console.log(quartal);

  useEffect(() => {
    getDataRevenue();
  }, []);

  return (
    <div className="h-screen m-10">
      <div className="flex justify-center items-center">
        <div className="font2 w-[50%]">
          <h1 className="text-[24px]">Business Total Revenue</h1>
        </div>
        <div className="flex justify-end items-center w-[50%]">
          {role === "business" && (
            <div className="flex justify-center items-center mr-8 ">
              <h4 className="mr-4">Add: </h4>
              <Link
                to="/business/dashboard/revenue-business/create"
                className="border-2 rounded-lg p-2 font2 shadow-[0_15px_12px_-12px_rgba(0,0,0,0.3)]"
              >
                Revenue Bar +
              </Link>
            </div>
          )}
          <div className="flex justify-center items-center gap-2">
            <div className="font2 text-[16px] text-gray-600">Filter</div>
            <div className="w-[10rem]">
              <ListGroup
                option={[
                  { value: "Per Quartal", label: "Per Quartal" },
                  { value: "Per Tahun", label: "Per Tahun" },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="w-full flex justify-center mt-6">
        <div className="w-5/6">
          <Bar data={data} options={options} />
        </div>
      </div>
    </div>
  );
};

export default Screen;
